module.exports = __webpack_public_path__ + "img/banner-12.29af4066.jpg";